import React, { Component } from 'react';
import { connect } from 'react-redux';
import xss from 'xss';

import * as BoardAction from '../../../../library/board/BoardAction';

import PostTitleViewer from '../../../common/components/board/PostTitleViewer';
import SlideUpDownAni from '../../../common/components/SlideUpDownAni';
import PostCategoryViewer from '../../../../library/board/components/PostCategoryViewer';

import { values } from '../config';
import { getQueryObjFromRouter } from '../../../../utils/miscUtils';

const xssFilter = new xss.FilterXSS();

const mapStateToProps = ({ BoardReducer }) => {
    return {
        postInfo: BoardReducer.postInfo,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getPostInfo: (postId) =>
            dispatch(
                BoardAction.getPostInfo(
                    values.BOARD_TYPE,
                    values.BOARD_NAME,
                    postId,
                    false,
                    false
                )
            ),
        initPostDetail: () => {
            dispatch(BoardAction.initPostDetail());
        },
    };
};

class Item extends Component {
    constructor(props) {
        super(props);

        this.onClickItem = this.onClickItem.bind(this);

        this.state = {
            html: '',
        };
    }

    componentDidMount() {
        const { index } = this.props;
        if (index === 0) {
            this.getPost();
        }
    }

    getPost() {
        const { post } = this.props;

        return this.props
            .getPostInfo(post.id)
            .then(() => {
                return this.getHtml();
            })
            .then(() => {
                this.props.onClickListItem(post.id);
            });
    }

    getHtml() {
        const { history, postInfo } = this.props;
        const searchText = history.query.search || '';
        const regExp = searchText ? new RegExp(searchText, 'g') : null;
        const html = regExp
            ? postInfo.html.replace(regExp, `<strong>${searchText}</strong>`)
            : postInfo.html;

        this.setState({
            html: xssFilter.process(html),
        });
    }

    //열려있는 포스트 아이디 획득
    onClickItem(event) {
        event.preventDefault();

        // 글자 클릭과 드래그 선택은 답변을 펼치거나 접지 않는다.
        const selection = window.getSelection();
        const start = this.selectionStart;
        this.selectionStart = null;
        const dragged =
            start &&
            (Math.abs(event.clientX - start.x) > 3 ||
                Math.abs(event.clientY - start.y) > 3);
        if (
            event.target.closest('.question-title-text, .tag > span') ||
            (event.detail > 0 &&
                dragged &&
                selection?.toString() &&
                (event.currentTarget.contains(selection.anchorNode) ||
                    event.currentTarget.contains(selection.focusNode)))
        ) {
            return;
        }

        const { post, openedPostId } = this.props;
        this.props.initPostDetail();

        if (post.id !== openedPostId) {
            this.getPost();
        } else {
            this.props.onClickListItem(0);
        }
    }

    render() {
        const { post, history, openedPostId } = this.props;
        const { html } = this.state;
        const isDown = post.id === openedPostId;
        return (
            <li className={`${isDown ? 'on' : 'hide'}`}>
                <a
                    href="#"
                    className="title"
                    draggable={false}
                    aria-expanded={isDown}
                    onMouseDown={(event) => {
                        this.selectionStart = {
                            x: event.clientX,
                            y: event.clientY,
                        };
                    }}
                    onClick={this.onClickItem}
                >
                    <em className="tag">
                        <PostCategoryViewer postInfo={this.props.post} />
                    </em>
                    <PostTitleViewer
                        classname="question-title-text"
                        postInfo={this.props.post}
                        searchText={
                            history.query.search ||
                            getQueryObjFromRouter(history)?.search ||
                            ''
                        }
                        searchWrap={'strong'}
                    />
                </a>
                <SlideUpDownAni isDown={isDown}>
                    <div className="ans">
                        <div dangerouslySetInnerHTML={{ __html: html }} />
                    </div>
                </SlideUpDownAni>
            </li>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Item);
